import { getReadableLocationId, Region } from '../../utils/regions';
import { IGk } from './gks';
import { ILocationData, IPikData } from '../../../typings/api';

export const getLocationId = (location: ILocationData) => getReadableLocationId(location.locationId);

export interface ILocation {
  name: string;
  jkCount: number;
  linkId: Region;
}

export function mapLocationData(pikData: IPikData, gks: IGk[]): ILocation[] {
  const parsedGksIds = gks.map(gk => gk.id);

  return pikData.data.locations.map(location => {
    const linkId = getLocationId(location);
    if (!linkId) {
      console.error(`Location ${location.name} has no appropriate string region id`); //todo: отправлять ошибку в sentry
    }

    return {
      jkCount: location.jkIds ? location.jkIds.filter(id => parsedGksIds.includes(id)).length : 0,
      linkId: linkId || location.locationId,
      name: location.name || '',
    };
  });
}
